import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute, NavigationEnd, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'lib-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: Breadcrumb[] = [];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.breadcrumbs = this._buildBreadcrumbHierarchy(this._activatedRoute.root);
    });
    // Initial build for when the component loads
    this.breadcrumbs = this._buildBreadcrumbHierarchy(this._activatedRoute.root);
  }

  private _buildBreadcrumbHierarchy(route: ActivatedRoute): Breadcrumb[] {
    const newBreadcrumbs: Breadcrumb[] = [];
    let currentRoute: ActivatedRoute | null = route.firstChild;
    let currentUrl = '';

    while (currentRoute) {
      if (currentRoute.outlet === 'primary') {
        const routeSnapshot = currentRoute.snapshot;
        const routePathSegments = routeSnapshot.url.map((segment) => segment.path);

        if (routePathSegments.length > 0) {
          const significantPath = routePathSegments.filter((p) => p.length > 0).join('/');
          if (significantPath.length > 0) {
            currentUrl += `/${significantPath}`;
          }
        }

        const label = routeSnapshot.data['breadcrumb'] as string;
        // Limpiamos la URL para evitar dobles slashes y aseguramos que haya una raíz
        const finalUrl = currentUrl.replace(/\/\/+/g, '/') || '/';

        // Lógica anti-duplicados
        if (label) {
          const lastBreadcrumb =
            newBreadcrumbs.length > 0 ? newBreadcrumbs[newBreadcrumbs.length - 1] : null;

          const isDuplicate =
            lastBreadcrumb && lastBreadcrumb.label === label && lastBreadcrumb.url === finalUrl;

          if (!isDuplicate) {
            newBreadcrumbs.push({ label, url: finalUrl });
          }
        }
      }
      currentRoute = currentRoute.firstChild;
    }
    return newBreadcrumbs;
  }

  goBack(): void {
    if (this.breadcrumbs.length > 1) {
      const previousBreadcrumbUrl = this.breadcrumbs[this.breadcrumbs.length - 2].url;
      this._router.navigateByUrl(previousBreadcrumbUrl);
    }
  }
}
